import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  Container,
  Table,
  Card,
  Alert,
  Pagination,
  Badge,
} from "react-bootstrap";
import axios from "axios";

const ITEMS_PER_PAGE = 10;

const statusVariant = (status) => {
  switch (status.toLowerCase()) {
    case "pending":
      return "warning";
    case "completed":
      return "success";
    case "cancelled":
      return "danger";
    default:
      return "secondary";
  }
};

const ViewCustomer = () => {
  const { id } = useParams();
  const [customer, setCustomer] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

   // Get authentication token from localStorage or wherever you store it
   const token = localStorage.getItem('admin_token');
   const headers = {
     'Authorization': `Bearer ${token}`
   };
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const customerRes = await axios.get(
          `${API_BASE}/api/customers_a/${id}`,{headers}
        );
        const ordersRes = await axios.get(
          `${API_BASE}/api/customers_a/${id}/orders`,{headers}
        );
        setCustomer(customerRes.data);
        setOrders(ordersRes.data);
      } catch (err) {
        console.error("Failed to fetch customer or orders", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const totalPages = Math.ceil(orders.length / ITEMS_PER_PAGE);
  const currentOrders = orders.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getOrderTotal = (items) => {
    return items.reduce(
      (total, item) =>
        total + Number(item.unit_price) * Number(item.quantity),
      0
    );
  };

  if (loading) return <p>Loading customer data...</p>;
  if (!customer) return <Alert variant="danger">Customer not found.</Alert>;

  return (
    <Container className="mt-4">
      {/* Customer Info */}
      <Card className="mb-4 shadow-sm border-primary">
        <Card.Body>
          <Card.Title className="mb-3 text-primary">👤 Customer Info</Card.Title>
          <p>
            <strong>🏢 Company:</strong> {customer.company_name}
          </p>
          <p>
            <strong>📧 Email:</strong> {customer.email}
          </p>
          <p>
            <strong>📞 Phone:</strong> {customer.phone}
          </p>
          <p>
            <strong>📍 Address:</strong> {customer.address}
          </p>
        </Card.Body>
      </Card>

      <h4 className="mb-3">📦 Orders</h4>

      {orders.length > 0 ? (
        <>
          {currentOrders.map((order) => (
            <Card
              className="mb-4 shadow-sm border-0"
              key={order.order_id}
              style={{ borderLeft: "5px solid #0d6efd" }}
            >
              <Card.Header
                className="d-flex justify-content-between align-items-center bg-light fw-semibold"
              >
                <div>
                  Order #{order.order_id} —{" "}
                  {new Date(order.order_date).toLocaleDateString()}
                </div>
                <Badge bg={statusVariant(order.order_status)}>
                  {order.order_status}
                </Badge>
              </Card.Header>

              <Card.Body>
                <p>
                  <strong>📝 Note:</strong>{" "}
                  {order.customer_note || "No note provided"}
                </p>
                <p>
                  <strong>🧾 Total Items:</strong> {order.items.length}
                </p>

                <Table
                  striped
                  bordered
                  hover
                  responsive
                  size="sm"
                  className="mt-3"
                >
                  <thead className="table-primary text-center">
                    <tr>
                      <th>#</th>
                      <th>Bread Type</th>
                      <th>Size</th>
                      <th>Qty</th>
                      <th>Unit Price</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {order.items.map((item, itemIdx) => (
                      <tr key={itemIdx}>
                        <td>{itemIdx + 1}</td>
                        <td>{item.bread_type}</td>
                        <td>{item.size}"</td>
                        <td>{item.quantity}</td>
                        <td>${Number(item.unit_price).toFixed(2)}</td>
                        <td>
                          $
                          {(
                            Number(item.unit_price) * Number(item.quantity)
                          ).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                    <tr className="fw-bold text-end">
                      <td colSpan="5">Order Total</td>
                      <td className="text-success">
                        ${getOrderTotal(order.items).toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          ))}

          {totalPages > 1 && (
            <Pagination className="justify-content-center mt-4">
              {[...Array(totalPages).keys()].map((num) => (
                <Pagination.Item
                  key={num + 1}
                  active={num + 1 === currentPage}
                  onClick={() => handlePageChange(num + 1)}
                >
                  {num + 1}
                </Pagination.Item>
              ))}
            </Pagination>
          )}
        </>
      ) : (
        <Alert variant="info">No orders found for this customer.</Alert>
      )}
    </Container>
  );
};

export default ViewCustomer;
